/**
 * @flow
 * @relayHash 4b2b2cf0fb583677fd5f60ed8860d0a0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TacticalMeetingChecklistItemsView_circle$ref = any;
export type TacticalMeetingChecklistItemsQueryVariables = {|
  circleDatabaseId: string,
  orgDatabaseId: string,
|};
export type TacticalMeetingChecklistItemsQueryResponse = {|
  +organization: ?{|
    +circle: ?{|
      +$fragmentRefs: TacticalMeetingChecklistItemsView_circle$ref
    |}
  |}
|};
export type TacticalMeetingChecklistItemsQuery = {|
  variables: TacticalMeetingChecklistItemsQueryVariables,
  response: TacticalMeetingChecklistItemsQueryResponse,
|};
*/


/*
query TacticalMeetingChecklistItemsQuery(
  $circleDatabaseId: String!
  $orgDatabaseId: String!
) {
  organization(databaseId: $orgDatabaseId) {
    circle(databaseId: $circleDatabaseId) {
      ...TacticalMeetingChecklistItemsView_circle
      id
    }
    id
  }
}

fragment TacticalMeetingChecklistItemsView_circle on Circle {
  databaseId
  organization {
    id
    databaseId
  }
  supportedRole {
    databaseId
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "circleDatabaseId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgDatabaseId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "orgDatabaseId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "circleDatabaseId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TacticalMeetingChecklistItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Circle",
            "kind": "LinkedField",
            "name": "circle",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TacticalMeetingChecklistItemsView_circle"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TacticalMeetingChecklistItemsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Circle",
            "kind": "LinkedField",
            "name": "circle",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "supportedRole",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4b2b2cf0fb583677fd5f60ed8860d0a0",
    "metadata": {},
    "name": "TacticalMeetingChecklistItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd4a17c1116b9dc0f7c80d6b041588334';

module.exports = node;
